import React, {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {LaptopMinimalCheck} from 'lucide-react'
import {useFamilyTree} from './Stage4_MainTree'
import {useTreeExtension} from './Stage5_TreeExtension'
import {TreeRenderer} from './Stage7_Rendering'
import {renderCustomNode} from './Stage3_NodeRender'
import TreeInstructionsTooltip from './TreeInstructionsTooltip'
import ZoomControls from './Stage6_ZoomControls'
import {API_URL} from '../../services/apiService'

export default function MainFamilyTreeComponent() {
  const [searchParams] = useSearchParams()
  const rootId = searchParams.get('rootId')
  const {t} = useTranslation()

  const {
    loading,
    error,
    treeData,
    zoom,
    setZoom,
    setTreeData,
    initializeTree,
    expandedNodes,
    setExpandedNodes,
  } = useFamilyTree()

  useEffect(() => {
    initializeTree(rootId)
  }, [rootId])

  const {handleNodeClick} = useTreeExtension(
      treeData,
      setTreeData,
      expandedNodes,
      setExpandedNodes,
  )

  return (
      <div className="relative w-full h-screen">
        <TreeInstructionsTooltip/>

        <div className="hidden tree-view:block w-full h-full">
          <ZoomControls zoom={zoom} setZoom={setZoom}/>
          <TreeRenderer
              loading={loading}
              error={error}
              treeData={treeData}
              zoom={zoom}
              handleNodeClick={handleNodeClick}
              renderCustomNode={renderCustomNode}
              API_URL={API_URL}
          />
        </div>

        <div className="tree-view:hidden w-full h-full flex items-center justify-center bg-[#f8f6f2]">
          <div className="max-w-sm mx-4 p-8 bg-white rounded-2xl shadow-lg border border-[#e6dfd4] text-center">
            <div className="flex justify-center mb-6">
              <LaptopMinimalCheck className="w-20 h-20 text-[#937c5d]"/>
            </div>
            <h2 className="text-2xl font-bold text-[#4a3f30] mb-4">
              {t('treeView.desktopOnly')}
            </h2>
            <p className="text-[#937c5d] text-lg">
              {t('treeView.desktopMessage')}
              <br/>
              {t('treeView.switchToDesktop')}
            </p>
          </div>
        </div>
      </div>
  )
}